import { animate, stagger } from "motion";

let isMobile = window.innerWidth < 768;

const createAnimation = () => {
	const spacing = isMobile ? 48 : 64;
	return animate([
		[".step-tile", { opacity: [0, 1] }, { delay: stagger(0.1), duration: 0.1 }],
		[".step:nth-last-child(-n+4)", { y: [0, spacing] }],
		[".step:nth-last-child(-n+3)", { y: [spacing, spacing * 2] }],
		[".step:nth-last-child(-n+2)", { y: [spacing * 2, spacing * 3] }],
		[".step:nth-last-child(-n+1)", { y: [spacing * 3, spacing * 4] }],
		[
			".step-label",
			// flicker effect
			{ opacity: [0, 1, 1, 0, 1] },
			{ duration: 0.1, delay: stagger(0.2), ease: "linear" },
		],
		[
			".step-dots",
			// mask in from right
			{ clipPath: ["inset(0 100% 0 0)", "inset(0 0 0 0)"] },
			{ delay: stagger(0.1) },
		],
		[
			".steps-repeat",
			// mask from bottom to top
			{ clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] },
		],
	]);
};

let animation = createAnimation();

window.addEventListener("resize", () => {
	const prevIsMobile = isMobile;
	isMobile = window.innerWidth < 768;
	console.log("resize", window.innerWidth, isMobile, prevIsMobile);
	if (prevIsMobile !== isMobile) {
		console.log("isMobile changed", isMobile);
		animation.cancel();
		animation = createAnimation();
	}
});
